<template>
  <div class="min-h-screen bg-white">
    <!-- Header -->
    <div class="border-b bg-white">
      <div class="max-w-4xl mx-auto px-6 py-4">
        <NuxtLink to="/" class="text-blue-600 hover:text-blue-700 font-medium">
          ← Back to Home
        </NuxtLink>
      </div>
    </div>

    <!-- Content -->
    <main class="max-w-4xl mx-auto px-6 py-12">
      <h1 class="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8">
        Support Center
      </h1>

      <div class="prose prose-slate max-w-none">
        <p class="text-lg text-slate-600 mb-8">
          We're here to help. If you have questions about GVGmall, our services, or need assistance, please reach out to our support team.
        </p>

        <section class="mb-8">
          <h2 class="text-xl font-bold text-slate-900 mb-4">Contact Support</h2>
          <p class="text-slate-600 mb-6">
            Our support team is available to assist you with any inquiries. We typically respond within 24 hours during business days.
          </p>
          
          <div class="bg-slate-50 border border-slate-200 rounded-xl p-6 mb-6">
            <div class="flex items-center gap-4">
              <div class="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center text-2xl">
                📧
              </div>
              <div>
                <div class="font-semibold text-slate-900">Email Support</div>
                <a href="mailto:support@gvgmall.co" class="text-blue-600 hover:text-blue-700 font-medium">
                  support@gvgmall.co
                </a>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-bold text-slate-900 mb-4">What We Can Help With</h2>
          <ul class="list-disc pl-6 text-slate-600 space-y-2">
            <li>General inquiries about GVGmall services</li>
            <li>Questions about digital software licensing</li>
            <li>Information about our delivery process</li>
            <li>Privacy and data-related questions</li>
            <li>Business partnership inquiries</li>
          </ul>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-bold text-slate-900 mb-4">Response Times</h2>
          <p class="text-slate-600">
            We aim to respond to all support requests within 24 hours during business days (Monday-Friday). Complex inquiries may require additional time for thorough investigation.
          </p>
        </section>

        <section class="mb-8">
          <h2 class="text-xl font-bold text-slate-900 mb-4">Legal Documents</h2>
          <p class="text-slate-600 mb-4">
            For your reference, our legal and policy documents are available:
          </p>
          <ul class="space-y-2">
            <li>
              <NuxtLink to="/legal/privacy-policy" class="text-blue-600 hover:text-blue-700">
                Privacy Policy
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/legal/terms-of-service" class="text-blue-600 hover:text-blue-700">
                Terms of Service
              </NuxtLink>
            </li>
            <li>
              <NuxtLink to="/legal/refund-policy" class="text-blue-600 hover:text-blue-700">
                Refund Policy
              </NuxtLink>
            </li>
          </ul>
        </section>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'institutional'
})

useSeoMeta({
  title: 'Support Center | GVGmall',
  description: 'GVGmall Support Center - Contact our team for assistance and inquiries.',
  ogTitle: 'Support Center | GVGmall',
  ogDescription: 'GVGmall Support Center - Contact our team for assistance.',
  robots: 'index,follow'
})

useHead({
  link: [
    { rel: 'canonical', href: 'https://www.gvgmall.co/legal/support' }
  ]
})
</script>
